export interface PasswordValidationResult {
  ok: boolean;
  error: string;
}

// passwordPolicy.ts
export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push('• be at least 8 characters.');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('• include a lowercase letter.');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('• include an uppercase letter.');
  }
  if (!/\d/.test(password)) {
    errors.push('• include a number.');
  }
  if (!/[@$!%*?&~#^()_+\-=[\]{};:,.<>/\\|]/.test(password)) {
    errors.push('• include a symbol (e.g. !@#$%).');
  }

  // Construct the error message
  let error_msg = '';
  if (errors.length > 0) {
    errors.unshift('Password is invalid because it must:');
    error_msg = errors.join('\n');
  }

  return {
    ok: errors.length === 0,
    error: error_msg
  };
}
